export enum Feature {
  Folders = 'folders',
  OneApiCountProfiles = 'oneapi-count-profiles',
  PersonalisedAsset = 'tmp-e-personalisation-asset',
  EmailTransactional = 'email-transactional',
  FormWebMerge = 'tmp-form-web-merge',
  SplitTest = 'tmp-e-split-test',
  Localisation = 'localisation',
  HidingTargetsAndTopics = 'tmp-hiding-targets-and-topics',
  PreFilledForms = 'pre-filled-forms',
  AudienceTypeService = 'audience-type-service',
  EfficyEnterpriseMANodes = 'ints-efficy-ent-ma-nodes',
  EfficyCrmSync = 'ints-efficy-ent-event-sync',
  EfficyEnterpriseEventSync = 'ints-efficy-ent-event-sync',
  FileImportScheduling = 'file-import-scheduling',
  SmsCreditSubscription = 'sms-credit-subscription',
}
